<template>
  <div class="layout-operator" v-if="index !== 0">
    <div class="layout-item__content">
      <lego-dropdown
        v-model="conditionItem.operator"
        :items="operatorItems"
        :readOnly="disabled"
        :isCheckScroll="isCheckScroll"
        @update:modelValue="handleEmitData"
        @show-dropdown="showDropdown"
        appendToBody
      />
    </div>
  </div>
  <div class="condition-item" :class="{ 'condition-item__disabled': disabled }">
    <div class="layout-item">
      <div class="layout-item__label">{{ $util.capitalize($t('label.condition')) }}</div>
      <div class="layout-item__content">
        <lego-dropdown
          v-model="conditionItem.field"
          :items="logFields"
          :readOnly="disabled"
          :isCheckScroll="isCheckScroll"
          @show-dropdown="showDropdown"
          @update:modelValue="handleEmitData"
          appendToBody
        >
          <!-- <template #itemText><span style="font-size: 13px">{{ conditionItem.field }}</span></template> -->
        </lego-dropdown>

        <lego-dropdown
          v-model="conditionItem.compare"
          :items="conditionItems"
          :isCheckScroll="isCheckScroll"
          :readOnly="disabled"
          @show-dropdown="showDropdown"
          @update:modelValue="handleEmitData"
          appendToBody
        />
      </div>
    </div>

    <div class="layout-item">
      <div class="layout-item__label">{{ $t('label.findValue') }}</div>
      <div class="layout-item__content">
        <lego-text-field
          ref="searchOptionValue"
          :disabled="disabled"
          :modelValue="conditionItem.value"
          :guide="searchPlaceholder"
          :isKeyHandler="false"
          :rules="validatorInput"
          :counter="100"
          clearable
          :isCounter="false"
          @update:modelValue="(value) => onValueInput(value)"
          disableInputMutation
        />
      </div>
    </div>

    <lego-icon
      v-if="index > 0 && !disabled"
      class="lego-modal__close btn-close"
      @click="handleRemoveItemCondition"
      >close
    </lego-icon>
  </div>
</template>
<script>
export default {
  name: 'condition-item',
  emits: ['change', 'remove', 'show-dropdown'],
  inject: ['setCondition'],
  props: {
    item: {
      type: Object,
      required: true
    },
    remove: {
      type: Function
    },
    disabled: {
      type: Boolean,
      required: false
    },
    logFields: {
      type: Array,
      default: () => []
    },
    index: {
      type: Number,
      required: true
    },
    isCheckScroll: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      operatorItems: [
        { value: 'AND', text: 'AND' },
        { value: 'OR', text: 'OR' }
      ],
      conditionItems: [
        { value: 'like', text: 'like' },
        { value: '!like', text: '!like' },
        { value: '=', text: '=' },
        { value: '!=', text: '!=' },
        { value: '__LT__=', text: '<=' },
        { value: '__LT__', text: '<' },
        { value: '__GT__=', text: '>=' },
        { value: '__GT__', text: '>' }
      ],
      validatorInput: [this.checkSearchOptionValue],
      conditionItem: {}
    };
  },
  computed: {
    searchPlaceholder() {
      if (!this.disabled) {
        return this.$t('page.log.searchCondition');
      } else {
        return '';
      }
    }
  },
  watch: {
    item: {
      handler(value) {
        this.conditionItem = this.$util.deepCopy(value);
        this.checkSearchOptionValue(value.value);
      },
      immediate: true,
      deep: true
    }
  },
  created() {},
  methods: {
    onValueInput(value) {
      if (value !== this.conditionItem.value) {
        this.setCondition(true);
        this.conditionItem.value = value;
        this.handleEmitData();
      }
    },
    checkSearchOptionValue(value) {
      const isPassText = /[^a-zA-Z가-힣ㄱ-ㅎㅏ-ㅣ0-9\s]/g.test(value);
      if (value.length > 0 && isPassText) {
        return this.$t('message.errorValidateInput');
      }

      return true;
    },

    handleEmitData() {
      this.$emit('change', this.conditionItem);
    },

    handleRemoveItemCondition() {
      if (!this.disabled) {
        this.$emit('remove');
      }
    },
    showDropdown() {
      this.$emit('show-dropdown');
    }
  }
};
</script>
<style lang="scss" scoped>
:deep {
  .message {
    margin-left: 0px;
  }
}

.condition-item {
  background-color: #f4f4f6;
  border-radius: 4px;
  padding: 12px 16px;
  position: relative;
  &__disabled {
    border: 1px solid #e3e4e8;
    background-color: #ffffff;
    :deep(.lego-dropdown__title) {
      border-color: #e3e4e8 !important;
    }
    :deep(.lego-text-field__input) {
      &:disabled {
        border-color: #e3e4e8;
      }
    }
  }
  .btn-close {
    z-index: 0;
  }
  :deep(.lego-modal__close.lego-icon) {
    top: 5px;
    right: 5px;
    padding: 2px;
    font-size: 16px;
  }

  .layout-item {
    &__label {
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 16px;
      color: #2e3138;
      text-align: left;
      margin-bottom: 4px;
    }

    &__content {
      display: flex;
      gap: 8px;
      width: 100%;
      user-select: none;
      .lego-dropdown {
        &.lego-dropdown--readonly {
          :deep(.lego-dropdown__icon) {
            svg {
              fill: #cfd2d8;
            }
          }
        }
        &:nth-child(2) {
          width: 76px;
          min-width: 76px;
          :deep(.lego-dropdown__title) {
            .lego-dropdown__selected {
              flex: 1;
            }
            .lego-dropdown__title-icon {
              margin-left: 5px;
            }
          }
        }
      }
    }

    &:nth-child(n + 2) {
      margin-top: 8px;
    }
  }
}
.layout-operator {
  user-select: none;
  display: flex;
  justify-content: center;
  :deep(.lego-dropdown) {
    min-width: 76px;
    &.lego-dropdown--readonly {
      .lego-dropdown__title {
        justify-content: center;
        background-color: #ffffff;
        .lego-dropdown__title-icon {
          display: none;
        }
      }
    }
    .lego-dropdown__title {
      border-width: 0;
      font-size: 13px;
      font-weight: 500;
      .lego-dropdown__selected {
        justify-content: flex-end;
      }
      .lego-dropdown__title-icon {
        margin-left: 4px;
      }
      &:focus {
        border-width: 0;
      }
    }
  }
}
</style>
